export const isValidEmoji = (emoji: string): boolean => {
	const invalidEmojiRegex = /([a-z\d_-]+):/;
	return !invalidEmojiRegex.test(emoji);
};
